$(document).ready(function(){
    var numberOfSlides = $(".home-carousel .single").length;
    let slider = null;
    
    if(numberOfSlides > 1){
        slider = $('.home-carousel').slick({
            arrows: true,
            dots: true,
            prevArrow: $('.js-prev'),
            nextArrow: $('.js-next'),
        });
    }
    else{
        slider = $('.home-carousel').slick({
            arrows: true,
            dots: false
        });
    }

    if(slider){
        $('.js-slider-count').html(numberOfSlides);
        $('.js-slider-slide').html(1);
        slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
            $('.js-slider-slide').html(nextSlide + 1);
        });
        slider.on('afterChange', function(event, slick, currentSlide, nextSlide){
            setTimeout(function(){
                $('.slick-dots li button').removeAttr('tabindex');
                $('.slick-dots li button').removeAttr('role');
            }, 0);
        });
        $('.slick-dots li button').removeAttr('tabindex');
        $('.slick-dots li button').removeAttr('role');
    }

    $('#homepage-filters .select select[name=offer_type]').on('change', function(){
        var form = $(this).closest("form");
        $('.select select[name=estate_type_parent]').html("");
        $('.select select[name=estate_type]').html("");
        $('.select select[name=location]').html("");
        $('.select select[name=estate_type]').parent().addClass("disabled");
        $('.select select[name=location]').parent().addClass("disabled");
        $('.select select[name=estate_type]').parent().find(".state-home").html("");
        $('.select select[name=location]').parent().find(".state-home").html("");
        $('.select select[name=estate_type_parent]').parent().find(".state-home").html("Odaberite");

        $('.select select[name=offer_type]').parent().addClass("selected");
        $('.select select[name=estate_type_parent]').parent().removeClass("selected");
        $('.select select[name=estate_type]').parent().removeClass("selected");
        $('.select select[name=location]').parent().removeClass("selected");
        $.ajax({
            url: $(form).attr("action"),
            method: "POST",
            data: $(form).serialize(),
            success: function(data){
                if(data.estate_type_parents){
                    $(".select select[name=estate_type_parent]").html(data.estate_type_parents);
                    $(".select select[name=estate_type_parent]").parent().removeClass("disabled");
                    $(".select select[name=estate_type_parent]").attr("disabled", false);
                }
                if(data.url){
                    $(form).attr("data-url", data.url);
                }
            },
            error: function(data){

            }
        });
    });

    $('#homepage-filters .select select[name=estate_type_parent]').on('change', function(){
        var form = $(this).closest("form");
        $('.select select[name=estate_type]').html("");
        $('.select select[name=location]').html("");
        $('.select select[name=location]').parent().addClass("disabled");
        $('.select select[name=estate_type]').parent().find(".state-home").html("Odaberite");
        $('.select select[name=location]').parent().find(".state-home").html("");

        $('.select select[name=estate_type_parent]').parent().addClass("selected");
        $('.select select[name=estate_type]').parent().removeClass("selected");
        $('.select select[name=location]').parent().removeClass("selected");
        $.ajax({
            url: $(form).attr("action"),
            method: "POST",
            data: $(form).serialize(),
            success: function(data){
                if(data.estate_types){
                    $(".select select[name=estate_type]").html(data.estate_types);
                    $(".select select[name=estate_type]").parent().removeClass("disabled");
                    $(".select select[name=estate_type]").attr("disabled", false);
                }
                if(data.url){
                    $(form).attr("data-url", data.url);
                }
            },
            error: function(data){

            }
        });
    });

    $('#homepage-filters .select select[name=estate_type]').on('change', function(){
        var form = $(this).closest("form");
        $('.select select[name=location]').parent().find(".state-home").html("Odaberite");

        $('.select select[name=estate_type]').parent().addClass("selected");
        $('.select select[name=location]').parent().removeClass("selected");
        $(".select select[name=location]").attr("disabled", false);
        $.ajax({
            url: $(form).attr("action"),
            method: "POST",
            data: $(form).serialize(),
            success: function(data){
                if(data.locations){
                    $(".select select[name=location]").html(data.locations);
                    $(".select select[name=location]").parent().removeClass("disabled");
                }
                if(data.url){
                    $(form).attr("data-url", data.url);
                }
            },
            error: function(data){

            }
        });
    });

    $('#homepage-filters .select select[name=location]').on('change', function(){
        var form = $(this).closest("form");

        $('.select select[name=location]').parent().addClass("selected");
        $.ajax({
            url: $(form).attr("action"),
            method: "POST",
            data: $(form).serialize(),
            success: function(data){
                if(data.url){
                    $(form).attr("data-url", data.url);
                }
            },
            error: function(data){

            }
        });
    });

    $("#homepage-filters").on("submit", function(e){
        e.preventDefault();
        window.location.href = $(this).data("url");
    });

    $("#homepage-filters .select .state-home").each(function(){
        var defaultState = $(this).parent().find("option:selected").text();
        $(this).html(defaultState);
        $(".select select").on("change", function(){
            $(this).parent().find(".state-home").html($(this).find("option:selected").text())
        });
    });

});


// WEBPACK FOOTER //
// src/js/bundle/index.js